import Link from 'components/CustomRoutingLink';
import style from './style.module.scss';
import Icon from 'components/Icon';
import {formatRating, plural} from 'core/helpers';
import React from 'react';
import cs from 'classnames';
import {IProductSnippet} from 'shared/types/productSnippet.types';

export const PLURAL_GRADE_WORDS = ['оценка', 'оценки', 'оценок'];

type TSimpleRating = {
    value: number;
    reviewsCount: number;
    reviewsUrl: string;
    onClick: IProductSnippet['analytics']['onReviewsClick'];
};

export const SimpleRating = (props: TSimpleRating) => {
    const {value, reviewsCount, reviewsUrl, onClick} = props;

    return (
        <Link className={cs(style.rating, style.rating_animated)} href={reviewsUrl} onClick={onClick}>
            <Icon icon={'star'} />
            <div className={style.rating__count}>{formatRating(value)}</div>
            <div className={style.rating__reviews}>
                &nbsp;{reviewsCount} {plural(reviewsCount, PLURAL_GRADE_WORDS)}
            </div>
        </Link>
    );
};
